import React from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { App } from './App';
import { msalInstance } from './auth/msalConfig';
import './styles/brand.css';

const _origFetch = window.fetch.bind(window);
window.fetch = function(input, init) {
  if (init?.headers) {
    const h = new Headers(init.headers);
    const auth = h.get('authorization');
    if (auth) { h.delete('authorization'); h.set('x-wicnic-token', auth); init = { ...init, headers: h }; }
  }
  return _origFetch(input, init);
};

const root = document.getElementById('root');
if (!root) throw new Error('No #root element found in index.html');
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().catch(err => console.error('[MSAL] redirect handling failed', err));
  createRoot(root).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  );
});